var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["mixin"]: () => (__WEBPACK_EXTERNAL_MODULE_vue3_click_away_761e7d42__.mixin) });